import { Component, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  MDBModalRef,
  MDBModalService,
  MdbStepperComponent,
} from "ng-uikit-pro-standard";
import { Cep } from "src/app/shared/models/cep.model";
import { CodigoTransacaoService } from "src/app/shared/services/codigo-transacao.service";
import { ConsultaCepService } from "src/app/shared/services/consulta-cep.service";
import { DdiService } from "src/app/shared/services/ddi.service";

import { EnderecoInvestidor } from "../../models/endereco-investidor.modal";
import {
  DadosContaInstituicao,
  DadosPagamentoOnline,
} from "../../models/solicitar-garantia.model";
import { BancoService } from "../../services/banco.service";
import { InsereEnderecoService } from "../../services/insere-endereco.service";
import { SolicitarGarantiaService } from "../../services/solicitar-garantia.service";
import { CadastroService } from 'src/app/auth/services/cadastro.service';
import { IUpdateEmpresas } from 'src/app/auth/models/register.model';

import Swal from "sweetalert2";
import { showError, showErrorViaArray } from "src/app/shared/utils/functions/notification.function";
import cep from "cep-promise";
import { PerfilService } from "../../services/perfil.service";
import { encryptStorage } from "../../../auth/utils/storage";
import { cnpj, cpf } from "cpf-cnpj-validator";
import { CnpjValidator } from 'src/app/shared/utils/validators/cnpj-validator';

@Component({
  selector: "app-solicitar-garantia",
  templateUrl: "./solicitar-garantia.component.html",
  styleUrls: ["./solicitar-garantia.component.scss"],
})
export class SolicitarGarantiaComponent implements OnInit {
  @ViewChild("stepper", {
    static: true,
  })
  stepper: MdbStepperComponent;

  formGarantiaInstituicao: FormGroup;
  formEndereco: FormGroup;
  formPagamentoOnline: FormGroup;
  formEmpresa: FormGroup;

  formArrayCorretoras: FormGroup;

  dadoInstituicao = {
    nomeInstituicao: "",
    dataLiquidacao: "",
  };

  arrayEstados = [
    {
      sigla: "AC",
      nome: "Acre",
    },
    {
      sigla: "AL",
      nome: "Alagoas",
    },
    {
      sigla: "AP",
      nome: "Amapá",
    },
    {
      sigla: "AM",
      nome: "Amazonas",
    },
    {
      sigla: "BA",
      nome: "Bahia",
    },
    {
      sigla: "CE",
      nome: "Ceará",
    },
    {
      sigla: "ES",
      nome: "Espírito Santo",
    },
    {
      sigla: "GO",
      nome: "Goiás",
    },
    {
      sigla: "MA",
      nome: "Maranhão",
    },
    {
      sigla: "MT",
      nome: "Mato Grosso",
    },
    {
      sigla: "MS",
      nome: "Mato Grosso do Sul",
    },
    {
      sigla: "MG",
      nome: "Minas Gerais",
    },
    {
      sigla: "PA",
      nome: "Pará",
    },
    {
      sigla: "PB",
      nome: "Paraíba",
    },
    {
      sigla: "PR",
      nome: "Paraná",
    },
    {
      sigla: "PE",
      nome: "Pernambuco",
    },
    {
      sigla: "PI",
      nome: "Piauí",
    },
    {
      sigla: "RJ",
      nome: "Rio de Janeiro",
    },
    {
      sigla: "RN",
      nome: "Rio Grande do Norte",
    },
    {
      sigla: "RS",
      nome: "Rio Grande do Sul",
    },
    {
      sigla: "RO",
      nome: "Rondônia",
    },
    {
      sigla: "RR",
      nome: "Roraima",
    },
    {
      sigla: "SC",
      nome: "Santa Catarina",
    },
    {
      sigla: "SP",
      nome: "São Paulo",
    },
    {
      sigla: "SE",
      nome: "Sergipe",
    },
    {
      sigla: "TC",
      nome: "Tocantins",
    },
    {
      sigla: "DF",
      nome: "Distrito Federal",
    },
  ];

  arrayDDi = [];
  arrayItems: {
    id: number;
    title: string;
  }[];

  corretoras: any[] = [
    {
      id: "",
      nome: "",
    },
  ];

  arrayCorretoras = [];
  arrayCorretorasSelecionadas = [];

  arrayBancos = [];

  exibirInstituicao: boolean = false;
  exibirAmbas: boolean = false;
  exibirCorretora: boolean = false;

  idPedido: string = "";
  cnpjEmpresa: string = "";
  nomeEmpresa: string = "";
  exibirRepresentantes: boolean = false;
  modalRef: MDBModalRef;

  exibirErro: boolean = false;
  editaRepresentantes: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private ddiService: DdiService,
    private insereEndereco: InsereEnderecoService,
    private bancoService: BancoService,
    private solicitarGarantia: SolicitarGarantiaService,
    private codigo: CodigoTransacaoService,
    private router: Router,
    private empresaService: PerfilService,
    private cadastroService: CadastroService
  ) {}

  ngOnInit(): void {
    this.createFormEndereco(new EnderecoInvestidor());
    this.createFormGarantiaInstituicao(new DadosContaInstituicao());
    this.criarForm();

    this.dadoInstituicao.nomeInstituicao =
      this.route.snapshot.paramMap.get("nome");
    this.dadoInstituicao.dataLiquidacao =
      this.route.snapshot.paramMap.get("data");
    this.idPedido = this.route.snapshot.paramMap.get("id");
    this.cnpjEmpresa = this.route.snapshot.paramMap.get("cnpjEmpresa");
    this.nomeEmpresa = this.route.snapshot.paramMap.get("nomeEmpresa");
    this.exibirRepresentantes = this.route.snapshot.paramMap.get("exibirRepresentantes") === 'true';

    this.listarPaises();
    this.listarBancos();
    this.listarCorretoras();

    this.createFormRepresentantes();
    this.fillDadosEmpresa();
  }
  // consultaCEP() {
  //   if (this.cep != "" && this.cep.length == 8) {
  //     return this.cepService.consultaCep(this.cep).subscribe(res => {
  //       this.dadosEndereco = res
  //     }, e => {
  //       console.log(e)
  //       // return this.alertaErro("Houve erros ao recarregar ")
  //     })
  //   }
  // }

  // addItem(corretora) {
  //   if (corretora != "") {
  //     this.arrayCorretorasSelecionadas.push(corretora);
  //   }
  //   console.log(console.log(this.arrayCorretorasSelecionadas))
  // }

  fillDadosEmpresa() {
  const cpfResponsavel = encryptStorage.getItem("@documentoIdentificador");

  this.empresaService
    .listarEmpresa(this.cnpjEmpresa, cpfResponsavel)
    .subscribe(
      (res) => {
        const dadosEmpresa = res["data"];

        this.editaRepresentantes = dadosEmpresa.editaRepresentantes;

        this.formEmpresa.patchValue({
          nomeEmpresa: dadosEmpresa.nomeEmpresa,
          cnpjEmpresa: dadosEmpresa.cnpj,
        });

        const repsArray = this.formEmpresa.get('representantes') as FormArray;
        const reps = dadosEmpresa?.representantes || [];

        const rep1 = reps[0] || { nome: '', cpf: '', emailPj: ''};
        repsArray.push(
          new FormGroup({
            nome: new FormControl(
              { value: rep1.nome || '', disabled: !this.editaRepresentantes },
              [Validators.required]
            ),
            cpf: new FormControl(
              { value: rep1.cpf || '', disabled: !this.editaRepresentantes },
              [Validators.required]
            ),
            emailPj: new FormControl(
              { value: rep1.emailPj || '', disabled: !this.editaRepresentantes },
              [Validators.required]
            ),
          })
        );

        const rep2 = reps[1] || { nome: '', cpf: '', emailPj: ''};
        repsArray.push(
          new FormGroup({
            nome: new FormControl(
              { value: rep2.nome || '', disabled: !this.editaRepresentantes }
            ),
            cpf: new FormControl(
              { value: rep2.cpf || '', disabled: !this.editaRepresentantes }
            ),
            emailPj: new FormControl(
              { value: rep2.emailPj || '', disabled: !this.editaRepresentantes }
            ),
          })
        );

        if (!this.editaRepresentantes) {
          this.formEmpresa.get('nomeEmpresa')?.disable();
        } else {
          this.formEmpresa.get('nomeEmpresa')?.enable();
        }

      },
      (e) => {
        return this.alertaErro(e.error.data.detalhesErro[0]);
      }
    );
}

  createFormRepresentantes() {
    this.formEmpresa = new FormGroup({
      nomeEmpresa: new FormControl('', [Validators.required, Validators.pattern(/^[^!"?\[\\\]‘’“”«»–.]*$/)]),
      cnpjEmpresa: new FormControl({value: '', disabled: true}, [Validators.required]),
      representantes: new FormArray([]),
    })
  }

  get representantes(): FormArray {
    return this.formEmpresa.get('representantes') as FormArray;
  }

  criarForm() {
    this.createFormConta(new DadosPagamentoOnline());
  }

  criarAmbas() {
    this.createFormConta(new DadosPagamentoOnline());
    this.createFormEndereco(new EnderecoInvestidor());
    this.createFormGarantiaInstituicao(new DadosContaInstituicao());
  }

  addItem(item) {
    if (item != "" || item != undefined) {
      this.arrayCorretorasSelecionadas.push(item);
    }
  }

  addCorretora() {
    this.corretoras.push({
      id: "",
      nome: "",
    });
  }
  removeCorretora(item) {
    this.corretoras.splice(item, 1);
  }

  // removeArray(item) {
  //   this.arrayCorretorasSelecionadas.splice(item, 1)
  //   console.log(this.arrayCorretoras);
  // }

  listarPaises() {
    return this.ddiService.consultaDDI().subscribe(
      (res) => {
        this.arrayDDi = res["data"]["ddis"];
      },
      (e) => {
        return this.alertaErro("Erro ao listar a lista de países.");
      }
    );
  }

  listarCorretoras() {
    this.bancoService
      .listarCorretoras(this.route.snapshot.paramMap.get("id"))
      .subscribe(
        (res) => {
          this.arrayCorretoras = res["data"]["corretoras"];
        },
        (e) => {}
      );
  }

  cadastroEndereco() {
    if (this.formEndereco.invalid) {
      this.exibirErro = true;
      return this.alertaErro(
        "Valide as informações do formulário para prosseguir."
      );
    }

    let dados = this.formEndereco.value;
    this.exibirErro = false;

    let body = {
      codigoTransacao: this.codigo.getUniqueId(5),
      data: this.formEndereco.value,
    };

    return this.insereEndereco.inserirEndereco(body).subscribe(
      (res) => {
        // this.notification.showMessageSucess('Endereço cadastrado com sucesso.')
        return this.stepper.next();
      },
      (e) => {
        if (e.status == 422) {
          return this.alertaErro(e.error.data.detalhesErro[0]);
        }
        this.alertaErro(
          "Ocorreu um erro na solicitação, por favor tente novamente em alguns instantes."
        );
      },
      () => {}
    );
    // console.log(this.formEndereco.value)
  }

  //   minSelectedCorretora(): ValidatorFn {
  //     const validator: ValidatorFn = (formArray: FormArray) => {

  //        const selectedCount = formArray.controls
  //           .map(control => control.value)
  //           .reduce((prev, next) => next ? prev + next : prev, 0);

  //        return selectedCount >= 1 ? null : { notSelected: true };
  //     };

  //     return validator;
  //  }

  listarBancos() {
    this.bancoService.listarBancos().subscribe(
      (res) => (this.arrayBancos = res["data"]["bancos"]),
      (e) => console.log
    );
  }

  solicitacaoConcluida() {
    // let config = {
    //   ignoreBackdropClick: true,
    //   scroll: true
    // }
    // this.modalRef = this.modalService.show(ModalSucessoComponent, config)
    this.alertaSucesso(
      "Clique no botão para ser redirecionado para tela inicial."
    );
  }

  confirmarSolicitacao(body, representantes: any[]) {
    const formValues = this.formEmpresa.getRawValue();

    const banco = this.arrayBancos.find(banco => banco.id === this.bancoPagamento.value);
    const nomeBanco = banco ? `${banco.nome}` : this.bancoPagamento.value;

    const tipoContaMap: Record<string, string> = {
      'CC': 'Corrente',
      'CP': 'Poupança',
    };

    const tipoConta = tipoContaMap[this.tipoContaPagamento.value] ?? this.tipoContaPagamento.value;

    const digitoAgencia = this.bancoId.value === '001'
      ? `<div>
          <span style="color: #888; padding: 2px 0;">Dígito Agência:</span>
          <span style="font-weight: 500;">${this.digitoAgencia.value || '-'}</span>
        </div>`
      : '';

    const representantesHtml = representantes
      .filter(rep => rep.nome || rep.cpf || rep.emailPj)
      .map((rep, i) => `
        <div style="margin-top: 10px; padding-top: 10px; border-top: 1px solid #eee;">
          <p style="font-weight: 600; color: #666; margin: 0 0 6px;">Representante ${i + 1}</p>
          <div style="width: 100%; border-collapse: collapse;">
            <div style="display: flex; gap:6px;">
              <span style="color: #888; white-space: nowrap;">Nome Completo:</span>
              <span style="font-weight: 500; word-break: break-word; min-width: 0;">${rep.nome || '-'}</span>
            </div>
            <div style="display: flex; gap:6px;">
              <span style="color: #888; white-space: nowrap;">CPF:</span>
              <span style="font-weight: 500; word-break: break-word; min-width: 0;">${rep.cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') || '-'}</span>
            </div>
            <div style="display: flex; gap:6px;">
              <span style="color: #888; white-space: nowrap;">E-mail:</span>
              <span style="font-weight: 500; word-break: break-word; min-width: 0;">${rep.emailPj || '-'}</span>
            </div>
          </div>
        </div>
      `).join('');

    let message = `
      As informações cadastradas irão compor o Termo que deverá ser assinado pelos representantes legais antes do pagamento.
      Pedimos, por gentileza, que realize a validação dos dados informados para garantir que o processo ocorra sem inconsistências.<br><br>

      <b>Verifique os pontos abaixo:</b><br><br>

      <ul style="text-align: left; padding-left: 3em;" >
        <li>Se plugins ou extensões do navegador estão desativados, pois podem interferir no preenchimento e envio dos dados;</li>
        <li>Se o nome da empresa e os dados dos representantes estão corretos;</li>
        <li>A conta bancária cadastrada deve ser de titularidade da empresa;</li>
        <li>O cadastro da conta deve ser feito sem o dígito, pois há campo específico para essa informação.</li>
      </ul>

      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; text-align: left; font-size: 14px;">
        <div style="background: var(--color-backgound-secundary, #f9f9f9); border-radius: 8px; padding: 14px;">
          <p style="font-weight: 600; color: #555; margin-bottom: 4px; border-bottom: 1px solid #eee; padding-bottom: 4px;">
            Dados dos Representantes
          </p>
          <div style="display: flex; flex-direction: column; gap: 6px;">
            <div style="display: flex; gap:6px;">
              <span style="color: #888; white-space: nowrap;">CNPJ Empresa:</span>
              <span style="font-weight: 500; word-break: break-word; min-width: 0;">${formValues.cnpjEmpresa?.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5')}</span>
            </div>
            <div style="display: flex; gap:6px;">
              <span style="color: #888; white-space: nowrap;">Nome/Razão Social:</span>
              <span style="font-weight: 500; word-break: break-word; min-width: 0;">${formValues.nomeEmpresa}</span>
            </div>
          </div>
          ${representantesHtml}
        </div>

        <div style="background: var(--color-backgound-secundary, #f9f9f9); border-radius: 8px; padding: 14px;">
          <p style="font-weight: 600; color: #555; margin-bottom: 4px; border-bottom: 1px solid #eee; padding-bottom: 4px;">
            Dados Bancários
          </p>
          <div style="display: flex; flex-direction: column; gap: 6px;">
            <div style="display: flex; gap:6px;">
              <span style="color: #888; white-space: nowrap;">Banco:</span>
              <span style="font-weight: 500; word-break: break-word; min-width: 0;">${nomeBanco}</span>
            </div>
            <div style="display: flex; gap:6px;">
              <span style="color: #888; white-space: nowrap;">Tipo Conta:</span>
              <span style="font-weight: 500; word-break: break-word; min-width: 0;">${tipoConta}</span>
            </div>
            <div style="display: flex; gap:6px;">
              <span style="color: #888; white-space: nowrap;">Agência:</span>
              <span style="font-weight: 500; word-break: break-word; min-width: 0;">${this.agenciaPagamento.value}</span>
            </div>
            ${digitoAgencia}
            <div style="display: flex; gap:6px;">
              <span style="color: #888; white-space: nowrap;">Conta:</span>
              <span style="font-weight: 500; word-break: break-word; min-width: 0;">${this.contaPagamento.value}</span>
            </div>
            <div style="display: flex; gap:6px;">
              <span style="color: #888; white-space: nowrap;">Dígito Conta:</span>
              <span style="font-weight: 500; word-break: break-word; min-width: 0;">${this.digitoContaPagamento.value}</span>
            </div>
          </div>
        </div>
      </div>`
    ;

    Swal.fire({
        title: "Atenção:",
        html: message,
        width: '50em',
        padding: '2em',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: '#00A676',
        cancelButtonColor: '#d33',
        confirmButtonText: "Confirmar",
        cancelButtonText: "Corrigir",
      }).then((result) => {
        if (result.isConfirmed) {
          this.cadastroService.editarDadosEmpresa(body).subscribe({
            next: () => {
              this.solicitarInstituicao();
            },
            error: (e) => {
              const errors = e?.error?.descricaoErro || [];
              return showErrorViaArray("", errors);
            }
          });
        }
      });
  }

  enviarForm(){
    if (this.bancoId.value == "001") {
      if (this.digitoAgencia.value === "" || this.digitoAgencia.value == null) {
        return this.alertaErro(
          "O campo 'Digito Agência' precisa ser informado."
        );
      }
    }

    const deveValidarFormEmpresa = this.editaRepresentantes;
    const formEmpresaValido = !deveValidarFormEmpresa || this.formEmpresa.valid;

    if (this.formPagamentoOnline.valid && formEmpresaValido) {
      const formValues = this.formEmpresa.getRawValue();
      const _representantes = formValues.representantes || [];
      const nomeEmpresaValue = formValues.nomeEmpresa;

      if (!nomeEmpresaValue || nomeEmpresaValue.trim().length === 0) {
        showError(
          "",
          `O campo Nome/Razão Social do Credor Pessoa Jurídica é obrigatório.`
        );
        return false;
      }

      if (this.formEmpresa.get("nomeEmpresa")?.hasError("pattern")) {
        showError(
          "",
          `O campo Nome/Razão Social do Credor Pessoa Jurídica contém caracteres inválidos.`
        );
        return false;
      }

      try {
        this.formEmpresa.get("cnpjEmpresa")?.setValue(CnpjValidator.create(formValues.cnpjEmpresa));
      } catch {
        showError("", `O CNPJ do Credor Pessoa Jurídica não é válido.`);
        return false;
      }

      if(this.validarRepresentantes(_representantes)){
        const body: IUpdateEmpresas = {
          cnpj: formValues.cnpjEmpresa,
          nomeEmpresa: formValues.nomeEmpresa,
          idPedido: this.idPedido,
          representantes: _representantes.filter((rep) => rep.nome && rep.cpf && rep.emailPj),
        };

        this.confirmarSolicitacao(body, _representantes);
      }
    } else {
      this.alertaErro(
        "Campos obrigatórios não preenchidos, valide o formulário para prosseguir."
      )
    }
  }

  validarRepresentantes(representantes){
    const nomes: string[] = [];
    const cpfs: string[] = [];
    const emails: string[] = [];

    const emailRegex = /^[A-Za-z0-9._+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    for (let i = 0; i < representantes.length; i++) {
      const rep = representantes.at(i);

      if(i > 0 && (!rep.nome && !rep.cpf && !rep.emailPj)) {
        continue; // Representante opcional não preenchido
      }

      if (!rep.nome || !rep.cpf || !rep.emailPj) {
        if(i === 0) {
          showError("", `Todos os campos do representante ${i + 1} são obrigatórios.`);
        } else{
          showError("", `Preencha todos os campos do representante ${i + 1}, ou deixe todos em branco.`);
        }
        return false;
      }

      const nome = rep?.nome?.toLowerCase()?.trim();
      const cpfRep = rep?.cpf?.trim();
      const emailPj = rep?.emailPj?.toLowerCase()?.trim();

      if (i === 0) {
        if (!nome || nome.length === 0) {
          showError(
            "",
            `O nome do Representante Legal ${i + 1} do Credor Pessoa Jurídica é obrigatório.`
          );
          return false;
        }
        if (!cpfRep || cpfRep.length === 0 || !cpf.isValid(cpfRep)) {
          showError(
            "",
            `O CPF do Representante Legal ${i + 1} do Credor Pessoa Jurídica é obrigatório.`
          );
          return false;
        }
        if (!emailPj || emailPj.length === 0) {
          showError(
            "",
            `O email do Representante Legal ${i + 1} é obrigatório.`
          );
          return false;
        }
      }

      if (emailPj && !emailRegex.test(emailPj)) {
        showError(
          "",
          `O email do Representante Legal ${i + 1} é inválido.`
        );
        return false;
        }

      if (cpfRep && !cpf.isValid(cpfRep)) {
        showError(
          "",
          `O CPF do Representante Legal na posição ${i + 1} é inválido.`
        );
        return false;
      }

      if (cpfRep && cpfs.includes(cpfRep)) {
        showError(
          "",
          `O CPF do Representante Legal "${cpfRep}" na posição ${i + 1} está duplicado.`
        );
        return false;
      }

      if (cpfRep) cpfs.push(cpfRep);

      if (nome && nomes.includes(nome)) {
        showError(
          "",
          `O nome do Representante Legal "${nome}" na posição ${i + 1} está duplicado.`
        );
        return false;
      }

      if (nome) nomes.push(nome);

      if (emailPj && emails.includes(emailPj)) {
        showError(
          "",
          `O email do Representante Legal "${emailPj}" na posição ${i + 1} está duplicado.`
        );
        return false;
      }

      if (emailPj) emails.push(emailPj);
    }

    return true;
  }

  onBancoChange(bancoId: string): void {
    if (bancoId !== '001') {
      this.formPagamentoOnline.get('digitoAgencia')?.reset();
    }
  }

  solicitarInstituicao() {
    let body = {
      codigoTransacao: this.codigo.getUniqueId(5),
      data: {
        nomeEmpresa: this.formEmpresa.get('nomeEmpresa').value,
        cnpjEmpresa:  this.formEmpresa.get('cnpjEmpresa').value,
        instituicaoId: this.route.snapshot.paramMap.get("id"),
        idPedido: this.idPedido,
        pagamentoOnline: false,
        dadosPagamento: {
          tipoConta: this.tipoContaPagamento.value,
          agencia: this.agenciaPagamento.value,
          bancoId: this.bancoPagamento.value,
          conta: this.contaPagamento.value,
          digitoConta: this.digitoContaPagamento.value,
          digitoAgencia: this.digitoAgencia.value,
        },
      },
    };

    return this.solicitarGarantia.solicitarGarantia(body).subscribe(
      (res) => {
        // return this.notification.showMessageSucess("")
        return this.solicitacaoConcluida();
      },
      (e) => {
        if (e.status == 422) {
          const errors = e?.error?.descricaoErro || [];
          return showErrorViaArray("", errors);
        }
        this.alertaErro(
          "Ocorreu um erro na solicitação, por favor tente novamente em alguns instantes."
        );
      },
      () => {}
    );
  }


  createFormGarantiaInstituicao(instituicao: DadosContaInstituicao) {
    this.formGarantiaInstituicao = new FormGroup({
      instituicaoId: new FormControl(this.route.snapshot.paramMap.get("id")),
      idPedido: new FormControl(''),
      diretoInstituicao: new FormControl(true),
      tipoConta: new FormControl(instituicao.tipoConta),
      agencia: new FormControl(instituicao.agencia),
      conta: new FormControl(instituicao.conta),
      digitoConta: new FormControl(instituicao.digitoConta),
    });
  }

  createFormConta(depositoConta: DadosPagamentoOnline) {
    this.formPagamentoOnline = new FormGroup({
      tipoContaPagamento: new FormControl(depositoConta.tipoConta, [
        Validators.required,
      ]),
      agenciaPagamento: new FormControl(depositoConta.agencia, [Validators.required, Validators.maxLength(4)]),
      bancoId: new FormControl(depositoConta.bancoId, [Validators.required]),
      digitoAgencia: new FormControl(depositoConta.digitoAgencia),
      contaPagamento: new FormControl(depositoConta.conta, [
        Validators.required, Validators.minLength(4), Validators.maxLength(22)
      ]),
      digitoContaPagamento: new FormControl(depositoConta.digitoConta, [Validators.required, Validators.maxLength(1)]),
    });
  }

  validateDataBank(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/^(\d*[a-zA-Z]?\d*).*$/, '$1').replace(/[^0-9a-zA-Z]/g, '');
  }

  createFormEndereco(enderecoInvestidor: EnderecoInvestidor) {
    enderecoInvestidor.instituicaoId = this.route.snapshot.paramMap.get("id");

    this.formEndereco = new FormGroup({
      instituicaoId: new FormControl(enderecoInvestidor.instituicaoId, [
        Validators.required,
      ]),
      pais: new FormControl(enderecoInvestidor.pais, [Validators.required]),
      endereco: new FormControl(enderecoInvestidor.endereco, [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(50),
      ]),
      complemento: new FormControl(enderecoInvestidor.complemento, [
        Validators.required,
        Validators.maxLength(50),
      ]),
      cep: new FormControl(enderecoInvestidor.cep, [Validators.required]),
      bairro: new FormControl(enderecoInvestidor.bairro, [
        Validators.required,
        Validators.maxLength(50),
      ]),
      cidade: new FormControl(enderecoInvestidor.cidade, [
        Validators.required,
        Validators.maxLength(50),
      ]),
      estado: new FormControl(enderecoInvestidor.estado, [
        Validators.required,
        Validators.maxLength(50),
      ]),
    });
  }

  consultaEndereco(event) {
    let dadosEndereco;
    if (this.cep.value.length == 8) {
      cep(this.cep.value, {
        timeout: 5000,
        providers: ["brasilapi"],
      })
        .then((res) => {
          dadosEndereco = res;
          this.endereco.setValue(dadosEndereco.street);
          this.cidade.setValue(dadosEndereco.city);
          this.bairro.setValue(dadosEndereco.neighborhood);
          this.estado.setValue(dadosEndereco.state);
          this.pais.setValue("Brasil");
        })
        .catch((e) => {
          return showError("", e.message);
        });
    } else {
      return console.log("CEP Inválido");
    }
  }
  // createFormCorretora(){
  //    return this.formArrayCorretoras = new FormGroup({
  //       id: new FormControl('', Validators.required),
  //       nome: new FormControl(''),
  //     });
  //   }

  // addItem(){
  //     // add address to the list
  //     const control = <FormArray>this.formArrayCorretoras.controls['times'];
  //     control.push(this.createFormCorretora());
  // }

  // addGroup() {
  //   // add address to the list
  //   const control = <FormArray>this.formArrayCorretoras.controls['times'];
  //   control.push(this.createFormCorretora());
  // }

  // removeGroup(i: number) {
  //   // remove address from the list
  //   const control = <FormArray>this.formArrayCorretoras.controls[];
  //   control.removeAt(i);
  // }

  selectedInstiuicao() {
    if (this.exibirInstituicao) {
      return "box-option p-5 selected-instituicao d-flex justify-content-center";
    }
    return "box-option p-5 d-flex justify-content-center";
  }
  selectedCorretora() {
    if (this.exibirCorretora) {
      return "box-option p-5 selected-corretora d-flex justify-content-center";
    }
    return "box-option p-5 d-flex justify-content-center";
  }

  selectedAmbas() {
    if (this.exibirAmbas) {
      return "box-option p-5 selected-ambas d-flex justify-content-center";
    }
    return "box-option p-5 d-flex justify-content-center";
  }

  // exibeAgenciaDigito(event){
  //   console.log(event)
  //   console.log(this.bancoId)
  // }

  alertaSucesso(message) {
    Swal.fire({
      title: "Sua solicitação foi recebida com sucesso.",
      icon: "success",
      html: `<p>${message}</p>`,
    }).then(() => {
      this.router.navigate(["/spg"]);
    });
  }

  alertaErro(errorMessage) {
    Swal.fire({
      title: "",
      icon: "error",
      html: `<p>${errorMessage}</p>`,
    });
  }

  previous() {
    this.router.navigate(["/spg/home-ordinaria"])
  }

  get digitoAgencia() {
    return this.formPagamentoOnline.get("digitoAgencia");
  }
  get bancoId() {
    return this.formPagamentoOnline.get("bancoId");
  }
  get tipoContaInstituicao() {
    return this.formGarantiaInstituicao.get("tipoConta");
  }

  get agenciaInstituicao() {
    return this.formGarantiaInstituicao.get("agencia");
  }
  get contaInstituicao() {
    return this.formGarantiaInstituicao.get("conta");
  }

  get digitoContaInstituicao() {
    return this.formGarantiaInstituicao.get("conta");
  }

  get tipoContaPagamento() {
    return this.formPagamentoOnline.get("tipoContaPagamento");
  }

  get agenciaPagamento() {
    return this.formPagamentoOnline.get("agenciaPagamento");
  }
  get contaPagamento() {
    return this.formPagamentoOnline.get("contaPagamento");
  }

  get digitoContaPagamento() {
    return this.formPagamentoOnline.get("digitoContaPagamento");
  }
  get bancoPagamento() {
    return this.formPagamentoOnline.get("bancoId");
  }

  get pais() {
    return this.formEndereco.get("pais");
  }

  get endereco() {
    return this.formEndereco.get("endereco");
  }
  get complemento() {
    return this.formEndereco.get("complemento");
  }

  get cep() {
    return this.formEndereco.get("cep");
  }
  get bairro() {
    return this.formEndereco.get("bairro");
  }

  get cidade() {
    return this.formEndereco.get("cidade");
  }

  get estado() {
    return this.formEndereco.get("estado");
  }
}

// idInstituicao:
